import {
  LocalStorageKey,
  LocalStorageValue,
  localStorageSchema,
} from './localStorageSchema'
import { validatedLocalStorage } from './validatedLocalStorage'

export const setLocalStorageItem = <K extends LocalStorageKey>(
  key: K,
  value: LocalStorageValue<K>,
) => {
  validatedLocalStorage.setItem(key, localStorageSchema[key], value)
}
